import React, { useEffect } from "react";
import { Card, Form, Row, Container, Col, Button } from "react-bootstrap";
import { GlobalState } from "contexts/GlobalState";
import "./style.scss";

export const ProfileView = ({labels,onClick}) => {
  const [globalUser,setGlobalUser] = GlobalState("user");

  useEffect(() => {});
  const handleClick = (e, name) => {
    e.preventDefault();
    onClick(name);
  };
  return (
    <div className="profile-view">
      <div className="wrapper">
        <div className="label">{labels.psychometric}</div>
        <div className="number">{globalUser.user.psychometric}</div>
        <div className="label">{labels.maturity}</div>
        <div className="number">{globalUser.user.maturity}</div>
        <div className="label">{labels.adapter}</div>
        <div className="number blue">{globalUser.user.adapter}</div>
      </div>
      <div
        className="edit-details"
        role="button"
        tabIndex="0"
        onClick={(e) => handleClick(e, "ProfileView")}
      >
        {labels.edit}
      </div>
      <div className="notes">{labels.notes}</div>
    </div>
  );
};
